import React from 'react';

import { useSelector } from 'react-redux';
import { If } from 'shared';
import { selectMediaQuery } from 'store/selectors';

import { Sidebar } from './Sidebar';
import { Container, Content } from './styles';
import Toolbar from './Toolbar';

interface IProps {
  children?: React.ReactNode;
}

const Default: React.FC<IProps> = ({ children }) => {
  const mediaQuery = useSelector(selectMediaQuery);

  return (
    <Container>
      <If condition={!mediaQuery.md}>
        <Sidebar />
      </If>

      <If condition={mediaQuery.md}>
        <Toolbar />
      </If>
      <Content>{children}</Content>
    </Container>
  );
};

export default Default;
